import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types';
import { scrollToTop } from 'common/utils';
import { SourcingSharedChooseChannelFormData } from 'modules/sourcing-shared/forms';
import { generateStartingTemplatedMessageController } from '../generateStartingTemplatedMessageController';

type HandleSourcingSharedChooseChannelNextControllerProps = {
  channelFormData: SourcingSharedChooseChannelFormData;
  get: SharedSourcingStoreApi['getState'];
  set: SharedSourcingStoreApi['setState'];
};

export const handleSourcingSharedChooseChannelNextController = async ({
  channelFormData,
  get,
  set
}: HandleSourcingSharedChooseChannelNextControllerProps) => {
  const { candidateBatch } = get();

  scrollToTop();
  set({
    step: 'JOB_INFORMATION',
    channelFormData
  });

  // Generate the starting templated message now that we have the channel
  if (candidateBatch) {
    await generateStartingTemplatedMessageController({
      get,
      set,
      jobDescription: candidateBatch.jobDescription,
      jobTitle: candidateBatch.jobDescriptionParsed?.jobTitle,
      employerName: candidateBatch.jobDescriptionParsed?.employerName,
      channel: channelFormData.channel
    });
  }
};
